// https://www.rothenberger.com/de-de
// https://www.rothenberger.com/de-de
// https://www.rothenberger.com/be-nl
// https://www.rothenberger.com/be-fr

const websitesMapping = [
  {
    title: "Australia – English",
    url: "https://rothenberger.com/au-en",
  },
  {
    title: "Belgium – Français (Belgique)",
    url: "https://rothenberger.com/be-fr",
  },
  {
    title: "Belgium – Nederlands (België)",
    url: "https://rothenberger.com/be-nl",
  },
  {
    title: "Bulgaria – Български (България)",
    url: "https://rothenberger.com/bg-bg",
  },
  {
    title: "Brasil – Português",
    url: "https://rothenberger.com/br-pt",
  },
  {
    title: "Czech Republic – Čeština (Česká Republika)",
    url: "https://rothenberger.com/cz-cz",
  },
  {
    title: "Germany – Deutsch (Deutschland)",
    url: "https://rothenberger.com/de-de",
  },
  {
    title: "Spain – Español (España)",
    url: "https://rothenberger.com/es-es",
  },
  {
    title: "France – Français",
    url: "https://rothenberger.com/fr-fr",
  },
  {
    title: "India – English",
    url: "https://rothenberger.com/in-en",
  },
  {
    title: "Italy – Italiano (Italia)",
    url: "https://rothenberger.com/it-it",
  },
  {
    title: "Hungary – Magyar (Magyarország)",
    url: "https://rothenberger.com/hu-hu",
  },
  {
    title: "Netherlands – Nederlands (Nederland)",
    url: "https://rothenberger.com/nl-nl",
  },
  {
    title: "Austria – Deutsch (Österreich)",
    url: "https://rothenberger.com/at-de",
  },
  {
    title: "Poland – Polski (Polska)",
    url: "https://rothenberger.com/pl-pl",
  },
  {
    title: "Portugal – Português",
    url: "https://rothenberger.com/pt-pt",
  },
  {
    title: "România – Română",
    url: "https://rothenberger.com/ro-ro",
  },
  {
    title: "Sweden – English",
    url: "https://rothenberger.com/scandi-en",
  },
  {
    title: "Iceland – English",
    url: "https://rothenberger.com/scandi-en",
  },
  {
    title: "Switzerland – Deutsch (Schweiz)",
    url: "https://rothenberger.com/ch-de",
  },
  {
    title: "Serbia – English",
    url: "https://rothenberger.com/rs-en",
  },
  {
    title: "Slovakia – Slovenský (Slovensko)",
    url: "https://rothenberger.com/sk-sk",
  },
  {
    title: "South Africa – English",
    url: "https://rothenberger.com/za-en",
  },
  {
    title: "Switzerland – Français (Suisse)",
    url: "https://rothenberger.com/ch-fr",
  },
  {
    title: "Switzerland – Italiano (Svizzera",
    url: "https://rothenberger.com/ch-it",
  },
  {
    title: "Turkey – Türkçe (Türkiye)",
    url: "https://rothenberger.com/tr-tr",
  },
  {
    title: "United Arab Emirates – English",
    url: "https://rothenberger.com/ae-en",
  },
  {
    title: "United Kingdom – English",
    url: "https://rothenberger.com/gb-en",
  },
  {
    title: "United States – English",
    url: "https://rothenberger.com/us-en",
  },
  {
    title: "Latvia – Latviešu",
    url: "https://rothenberger.com/lv-lv",
  },
]

const countriesHostsMappingByEnv = {
  development: {
    ae: "https://ro-ae-staging.netlify.app",
    at: "https://ro-at-staging.netlify.app",
    au: "https://ro-au-staging.netlify.app",
    be: "https://ro-be-staging.netlify.app",
    bg: "https://ro-bg-staging.netlify.app",
    br: "https://ro-br-staging.netlify.app",
    ch: "https://ro-ch-staging.netlify.app",
    cz: "https://ro-cz-staging.netlify.app",
    de: "https://ro-de-staging.netlify.app",
    es: "https://ro-es-staging.netlify.app",
    fr: "https://ro-fr-staging.netlify.app",
    gb: "https://ro-gb-staging.netlify.app",
    hu: "https://ro-hu-staging.netlify.app",
    in: "https://ro-in-staging.netlify.app",
    it: "https://ro-it-staging.netlify.app",
    lv: "https://ro-lv-staging.netlify.app",
    nl: "https://ro-nl-staging.netlify.app",
    pl: "https://ro-pl-staging.netlify.app",
    pt: "https://ro-pt-staging.netlify.app",
    ro: "https://ro-ro-staging.netlify.app",
    rs: "https://ro-rs-staging.netlify.app",
    scandi: "https://ro-scandi-staging.netlify.app",
    sk: "https://ro-sk-staging.netlify.app",
    tr: "https://ro-tr-staging.netlify.app",
    us: "https://ro-us-staging.netlify.app",
    za: "https://ro-za-staging.netlify.app",
  },
  staging: {
    ae: "https://ro-ae-staging.netlify.app",
    at: "https://ro-at-staging.netlify.app",
    au: "https://ro-au-staging.netlify.app",
    be: "https://ro-be-staging.netlify.app",
    bg: "https://ro-bg-staging.netlify.app",
    br: "https://ro-br-staging.netlify.app",
    ch: "https://ro-ch-staging.netlify.app",
    cz: "https://ro-cz-staging.netlify.app",
    de: "https://ro-de-staging.netlify.app",
    es: "https://ro-es-staging.netlify.app",
    fr: "https://ro-fr-staging.netlify.app",
    gb: "https://ro-gb-staging.netlify.app",
    hu: "https://ro-hu-staging.netlify.app",
    in: "https://ro-in-staging.netlify.app",
    it: "https://ro-it-staging.netlify.app",
    lv: "https://ro-lv-staging.netlify.app",
    nl: "https://ro-nl-staging.netlify.app",
    pl: "https://ro-pl-staging.netlify.app",
    pt: "https://ro-pt-staging.netlify.app",
    ro: "https://ro-ro-staging.netlify.app",
    rs: "https://ro-rs-staging.netlify.app",
    scandi: "https://ro-scandi-staging.netlify.app",
    sk: "https://ro-sk-staging.netlify.app",
    tr: "https://ro-tr-staging.netlify.app",
    us: "https://ro-us-staging.netlify.app",
    za: "https://ro-za-staging.netlify.app",
  },
  production: {
    ae: "https://ro-ae.netlify.app",
    at: "https://ro-at.netlify.app",
    au: "https://ro-au.netlify.app",
    be: "https://ro-be.netlify.app",
    bg: "https://ro-bg.netlify.app",
    br: "https://ro-br.netlify.app",
    ch: "https://ro-ch.netlify.app",
    cz: "https://ro-cz.netlify.app",
    de: "https://ro-de.netlify.app",
    es: "https://ro-es.netlify.app",
    fr: "https://ro-fr.netlify.app",
    gb: "https://ro-gb.netlify.app",
    hu: "https://ro-hu.netlify.app",
    in: "https://ro-in.netlify.app",
    it: "https://ro-it.netlify.app",
    lv: "https://ro-lv.netlify.app",
    nl: "https://ro-nl.netlify.app",
    pl: "https://ro-pl.netlify.app",
    pt: "https://ro-pt.netlify.app",
    ro: "https://ro-ro.netlify.app",
    rs: "https://ro-rs.netlify.app",
    scandi: "https://ro-scandi.netlify.app",
    sk: "https://ro-sk.netlify.app",
    tr: "https://ro-tr.netlify.app",
    us: "https://ro-us.netlify.app",
    za: "https://ro-za.netlify.app",
  },
}

const corporateServiceMappingByEnv = {
  development: [
    {
      countryLang: "de-de",
      serviceUrl: "https://ro-www-staging.yum-labs.com/de-de/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/de-de/",
    },
    {
      countryLang: "be-fr",
      serviceUrl: "https://ro-www-staging.yum-labs.com/be-fr/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/be-fr/",
    },
    {
      countryLang: "be-nl",
      serviceUrl: "https://ro-www-staging.yum-labs.com/be-nl/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/be-nl/",
    },
    {
      countryLang: "au-en",
      serviceUrl: "https://ro-www-staging.yum-labs.com/au-en/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/au-en/",
    },
    {
      countryLang: "es-es",
      serviceUrl: "https://ro-www-staging.yum-labs.com/es-es/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/es-es/",
    },
    {
      countryLang: "pt-pt",
      serviceUrl: "https://ro-www-staging.yum-labs.com/pt-pt/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/pt-pt/",
    },
    {
      countryLang: "bg-bg",
      serviceUrl: "https://ro-www-staging.yum-labs.com/bg-bg/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/bg-bg/",
    },
    {
      countryLang: "ch-de",
      serviceUrl: "https://ro-www-staging.yum-labs.com/ch-de/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/ch-de/",
    },
    {
      countryLang: "ch-fr",
      serviceUrl: "https://ro-www-staging.yum-labs.com/ch-fr/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/ch-fr/",
    },
    {
      countryLang: "ch-it",
      serviceUrl: "https://ro-www-staging.yum-labs.com/ch-it/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/ch-it/",
    },
    {
      countryLang: "pl-pl",
      serviceUrl: "https://ro-www-staging.yum-labs.com/pl-pl/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/pl-pl/",
    },
    {
      countryLang: "it-it",
      serviceUrl: "https://ro-www-staging.yum-labs.com/it-it/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/it-it/",
    },
    {
      countryLang: "br-pt",
      serviceUrl: "https://ro-www-staging.yum-labs.com/br-pt/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/br-pt/",
    },
  ],
  staging: [
    {
      countryLang: "de-de",
      serviceUrl: "https://ro-www-staging.yum-labs.com/de-de/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/de-de/",
    },
    {
      countryLang: "be-fr",
      serviceUrl: "https://ro-www-staging.yum-labs.com/be-fr/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/be-fr/",
    },
    {
      countryLang: "be-nl",
      serviceUrl: "https://ro-www-staging.yum-labs.com/be-nl/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/be-nl/",
    },
    {
      countryLang: "au-en",
      serviceUrl: "https://ro-www-staging.yum-labs.com/au-en/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/au-en/",
    },
    {
      countryLang: "es-es",
      serviceUrl: "https://ro-www-staging.yum-labs.com/es-es/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/es-es/",
    },
    {
      countryLang: "pt-pt",
      serviceUrl: "https://ro-www-staging.yum-labs.com/pt-pt/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/pt-pt/",
    },
    {
      countryLang: "bg-bg",
      serviceUrl: "https://ro-www-staging.yum-labs.com/bg-bg/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/bg-bg/",
    },
    {
      countryLang: "ch-de",
      serviceUrl: "https://ro-www-staging.yum-labs.com/ch-de/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/ch-de/",
    },
    {
      countryLang: "ch-fr",
      serviceUrl: "https://ro-www-staging.yum-labs.com/ch-fr/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/ch-fr/",
    },
    {
      countryLang: "ch-it",
      serviceUrl: "https://ro-www-staging.yum-labs.com/ch-it/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/ch-it/",
    },
    {
      countryLang: "pl-pl",
      serviceUrl: "https://ro-www-staging.yum-labs.com/pl-pl/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/pl-pl/",
    },
    {
      countryLang: "it-it",
      serviceUrl: "https://ro-www-staging.yum-labs.com/it-it/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/it-it/",
    },
    {
      countryLang: "br-pt",
      serviceUrl: "https://ro-www-staging.yum-labs.com/br-pt/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/br-pt/",
    },
    {
      countryLang: "gb-en",
      serviceUrl: "https://ro-www-staging.yum-labs.com/gb-en/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/gb-en/",
    },
    {
      countryLang: "nl-nl",
      serviceUrl: "https://ro-www-staging.yum-labs.com/nl-nl/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/nl-nl/",
    },
    {
      countryLang: "hu-hu",
      serviceUrl: "https://ro-www-staging.yum-labs.com/hu-hu/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/hu-hu/",
    },
    {
      countryLang: "at-de",
      serviceUrl: "https://ro-www-staging.yum-labs.com/at-de/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/at-de/",
    },
    {
      countryLang: "scandi-en",
      serviceUrl: "https://ro-www-staging.yum-labs.com/scandi-en/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/scandi-en/",
    },
    {
      countryLang: "cz-cz",
      serviceUrl: "https://ro-www-staging.yum-labs.com/cz-cz/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/cz-cz/",
    },
    {
      countryLang: "ro-ro",
      serviceUrl: "https://ro-www-staging.yum-labs.com/ro-ro/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/ro-ro/",
    },
    {
      countryLang: "rs-en",
      serviceUrl: "https://ro-www-staging.yum-labs.com/rs-en/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/rs-en/",
    },
    {
      countryLang: "sk-sk",
      serviceUrl: "https://ro-www-staging.yum-labs.com/sk-sk/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/sk-sk/",
    },
    {
      countryLang: "fr-fr",
      serviceUrl: "https://ro-www-staging.yum-labs.com/fr-fr/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/fr-fr/",
    },
    {
      countryLang: "tr-tr",
      serviceUrl: "https://ro-www-staging.yum-labs.com/tr-tr/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/tr-tr/",
    },
    {
      countryLang: "us-en",
      serviceUrl: "https://ro-www-staging.yum-labs.com/us-en/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/us-en/",
    },
    {
      countryLang: "in-en",
      serviceUrl: "https://ro-www-staging.yum-labs.com/in-en/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/in-en/",
    },
    {
      countryLang: "za-en",
      serviceUrl: "https://ro-www-staging.yum-labs.com/za-en/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/za-en/",
    },
    {
      countryLang: "ae-en",
      serviceUrl: "https://ro-www-staging.yum-labs.com/ae-en/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/ae-en/",
    },
    {
      countryLang: "lv-lv",
      serviceUrl: "https://ro-www-staging.yum-labs.com/lv-lv/",
      corporateUrl: "https://ro-corporate-staging.yum-labs.com/lv-lv/",
    },
  ],
  production: [
    {
      countryLang: "de-de",
      serviceUrl: "https://rothenberger.com/de-de/",
      corporateUrl: "https://corporate.rothenberger.com/de-de/",
    },
    {
      countryLang: "be-fr",
      serviceUrl: "https://rothenberger.com/be-fr/",
      corporateUrl: "https://corporate.rothenberger.com/be-fr/",
    },
    {
      countryLang: "be-nl",
      serviceUrl: "https://rothenberger.com/be-nl/",
      corporateUrl: "https://corporate.rothenberger.com/be-nl/",
    },
    {
      countryLang: "au-en",
      serviceUrl: "https://rothenberger.com/au-en/",
      corporateUrl: "https://corporate.rothenberger.com/au-en/",
    },
    {
      countryLang: "es-es",
      serviceUrl: "https://rothenberger.com/es-es/",
      corporateUrl: "https://corporate.rothenberger.com/es-es/",
    },
    {
      countryLang: "pt-pt",
      serviceUrl: "https://rothenberger.com/pt-pt/",
      corporateUrl: "https://corporate.rothenberger.com/pt-pt/",
    },
    {
      countryLang: "bg-bg",
      serviceUrl: "https://rothenberger.com/bg-bg/",
      corporateUrl: "https://corporate.rothenberger.com/bg-bg/",
    },
    {
      countryLang: "ch-de",
      serviceUrl: "https://rothenberger.com/ch-de/",
      corporateUrl: "https://corporate.rothenberger.com/ch-de/",
    },
    {
      countryLang: "ch-fr",
      serviceUrl: "https://rothenberger.com/ch-fr/",
      corporateUrl: "https://corporate.rothenberger.com/ch-fr/",
    },
    {
      countryLang: "ch-it",
      serviceUrl: "https://rothenberger.com/ch-it/",
      corporateUrl: "https://corporate.rothenberger.com/ch-it/",
    },
    {
      countryLang: "pl-pl",
      serviceUrl: "https://rothenberger.com/pl-pl/",
      corporateUrl: "https://corporate.rothenberger.com/pl-pl/",
    },
    {
      countryLang: "it-it",
      serviceUrl: "https://rothenberger.com/it-it/",
      corporateUrl: "https://corporate.rothenberger.com/it-it/",
    },
    {
      countryLang: "br-pt",
      serviceUrl: "https://rothenberger.com/br-pt/",
      corporateUrl: "https://corporate.rothenberger.com/br-pt/",
    },
    {
      countryLang: "gb-en",
      serviceUrl: "https://rothenberger.com/gb-en/",
      corporateUrl: "https://corporate.rothenberger.com/gb-en/",
    },
    {
      countryLang: "nl-nl",
      serviceUrl: "https://rothenberger.com/nl-nl/",
      corporateUrl: "https://corporate.rothenberger.com/nl-nl/",
    },
    {
      countryLang: "hu-hu",
      serviceUrl: "https://rothenberger.com/hu-hu/",
      corporateUrl: "https://corporate.rothenberger.com/hu-hu/",
    },
    {
      countryLang: "at-de",
      serviceUrl: "https://rothenberger.com/at-de/",
      corporateUrl: "https://corporate.rothenberger.com/at-de/",
    },
    {
      countryLang: "scandi-en",
      serviceUrl: "https://rothenberger.com/scandi-en/",
      corporateUrl: "https://corporate.rothenberger.com/scandi-en/",
    },
    {
      countryLang: "cz-cz",
      serviceUrl: "https://rothenberger.com/cz-cz/",
      corporateUrl: "https://corporate.rothenberger.com/cz-cz/",
    },
    {
      countryLang: "ro-ro",
      serviceUrl: "https://rothenberger.com/ro-ro/",
      corporateUrl: "https://corporate.rothenberger.com/ro-ro/",
    },
    {
      countryLang: "rs-en",
      serviceUrl: "https://rothenberger.com/rs-en/",
      corporateUrl: "https://corporate.rothenberger.com/rs-en/",
    },
    {
      countryLang: "sk-sk",
      serviceUrl: "https://rothenberger.com/sk-sk/",
      corporateUrl: "https://corporate.rothenberger.com/sk-sk/",
    },
    {
      countryLang: "fr-fr",
      serviceUrl: "https://rothenberger.com/fr-fr/",
      corporateUrl: "https://corporate.rothenberger.com/fr-fr/",
    },
    {
      countryLang: "tr-tr",
      serviceUrl: "https://rothenberger.com/tr-tr/",
      corporateUrl: "https://corporate.rothenberger.com/tr-tr/",
    },
    {
      countryLang: "us-en",
      serviceUrl: "https://rothenberger.com/us-en/",
      corporateUrl: "https://corporate.rothenberger.com/us-en/",
    },
    {
      countryLang: "in-en",
      serviceUrl: "https://rothenberger.com/in-en/",
      corporateUrl: "https://corporate.rothenberger.com/in-en/",
    },
    {
      countryLang: "za-en",
      serviceUrl: "https://rothenberger.com/za-en/",
      corporateUrl: "https://corporate.rothenberger.com/za-en/",
    },
    {
      countryLang: "ae-en",
      serviceUrl: "https://rothenberger.com/ae-en/",
      corporateUrl: "https://corporate.rothenberger.com/ae-en/",
    },
    {
      countryLang: "lv-lv",
      serviceUrl: "https://rothenberger.com/lv-lv/",
      corporateUrl: "https://corporate.rothenberger.com/lv-lv/",
    },
  ],
}

module.exports = {
  websitesMapping: websitesMapping,
  corporateServiceMappingByEnv: corporateServiceMappingByEnv,
  countriesHostsMappingByEnv: countriesHostsMappingByEnv,
}
